import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { CreateSubscriptionCheckoutPayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: CreateSubscriptionCheckoutPayload) =>
    $actions.billing.getLtdUpcomingInvoice(dispatch, payload),
  );
};
